import React from "react";
import commonClasses from "./General.module.css";
import classes from "./Profile.module.css";
import image from "./Person_icon_BLACK-01.svg.png";
import { FloatLabel } from "../../Utils/CustomComponent";
import MenuDownIcon from "mdi-react/MenuDownIcon";

function EditProfile() {
  return (
    <div >
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <div className="p-3 pb-0  mt-1">
          <div>
            <ul className={commonClasses.unorderedList}>
              <li>Profile</li>
              <li>
                <span className={commonClasses.spanMargin}>\</span>
              </li>
              <li className={commonClasses.breadcrumbColor}>Edit Profile</li>
            </ul>
          </div>
          <div className={`${classes.bgWhite} ${classes.editProfile}`}>
            <form>
              <div>
                <img className={classes.imageEditProfile} alt="" src={image} />
              </div>
              <div
                className="form-outline mb-5 d-flex"
                style={{ marginTop: "193px", gap: "38px" }}
              >
                <div style={{ width: "50%" }}>
                  <FloatLabel label={"Full Name"}>
                    <input
                      type="text"
                      className="form-control mb-4"
                      style={{
                        background: "white",
                        padding: "19px 24px",
                        height: "56px",
                      }}
                    />
                  </FloatLabel>
                </div>
                <div style={{ width: "50%" }}>
                  <FloatLabel label={"Company Name"}>
                    <input
                      type="text"
                      className="form-control mb-4"
                      style={{
                        background: "white",
                        padding: "19px 24px",
                        height: "56px",
                      }}
                    />
                  </FloatLabel>
                </div>
              </div>
              <div className="form-outline mb-5">
                <FloatLabel label={"Address *"}>
                  <input
                    type="address"
                    className="form-control mb-4"
                    style={{
                      background: "white",
                      padding: "19px 24px",
                      height: "80px",
                    }}
                  />
                </FloatLabel>
              </div>
              <div className="d-flex" style={{ gap: "38px" }}>
                <div className="form-group  flex-grow-1">
                  <label
                    htmlFor="city-select"
                    className={`mb-2 ${classes.labelEditProfile}`}
                  >
                    City
                  </label>
                  <div className="position-relative">
                    <select
                      className="form-control"
                      id="city-select"
                      style={{ height: "48px" }}

                      // width="500px"
                    >
                      <option value="">Select a city</option>
                      <option value="santa-ana">Santa Ana</option>
                      <option value="new-york">New York</option>
                      <option value="los-angeles">Los Angeles</option>
                    </select>
                    <MenuDownIcon
                      className="position-absolute end-0 m-3"
                      style={{ top: "7px" }}
                      size={24}
                    />
                  </div>
                </div>
                <div className="form-group flex-grow-1">
                  <label
                    htmlFor="state-select"
                    className={`mb-2 ${classes.labelEditProfile}`}
                  >
                    State
                  </label>
                  <div className="position-relative">
                    <select
                      className="form-control"
                      id="state-select"
                      style={{ height: "48px" }}
                      // width="500px"
                    >
                      <option value="">Select a State</option>
                      <option value="illinois">Illinois</option>
                    </select>
                    <MenuDownIcon
                      className="position-absolute end-0 m-3"
                      style={{ top: "7px" }}
                      size={24}
                    />
                  </div>
                </div>
                <div className="form-group flex-grow-1">
                  <label
                    htmlFor="zip-code-input"
                    className={`mb-2 ${classes.labelEditProfile}`}
                  >
                    Zip Code
                  </label>
                  <input
                    style={{ height: "48px" }}
                    type="text"
                    className="form-control"
                    id="zip-code-input"
                    placeholder="Enter Zip Code"
                  />
                </div>
              </div>
              <div
                className="form-outline d-flex"
                style={{ margin: "30px 0px", gap: "38px" }}
              >
                <div style={{ width: "50%" }}>
                  <FloatLabel label={"Phone Number"}>
                    <input
                      type="text"
                      className="form-control mb-4"
                      style={{
                        background: "white",
                        padding: "19px 24px",
                        height: "56px",
                      }}
                    />
                  </FloatLabel>
                </div>
                <div style={{ width: "50%" }}>
                  <FloatLabel label={"Email"}>
                    <input
                      type="text"
                      className="form-control mb-4"
                      style={{
                        background: "white",
                        padding: "19px 24px",
                        height: "56px",
                      }}
                    />
                  </FloatLabel>
                </div>
              </div>
              <button
                className="btn my-2 btn-lg btn-primary btn-block m-auto text-white py-4"
                style={{ fontWeight: "500", fontSize: "18px" }}
              >
                Save Changes
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default EditProfile;
